// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
	FILE: _core.scss

	USED ON:
		- srprs.me/*

	USAGE:
		Meant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1

	NOTES:
		NEVER use @import "base/*"; or such, read this => http://stackoverflow.com/a/4779432
*/
.clearfix {
  overflow: auto;
}

.display-flex {
  display: inline;
}
@media only screen and (min-width: 767px) {
  .display-flex {
    display: flex;
  }
}

.full-width {
  width: 100%;
}

@media only screen and (max-width: 767px) {
  .mobile-full-width {
    width: 100%;
  }
}

@media only screen and (min-width: 767px) {
  .width-49 {
    width: 49%;
  }
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.margin-b-s {
  margin-bottom: 10px;
}

.margin-b-m {
  margin-bottom: 20px;
}

.margin-b-l {
  margin-bottom: 40px;
}

.padding-t-s {
  padding-top: 10px;
}

.padding-t-s-7 {
  padding-top: 7px;
}

.padding-l-s {
  padding-left: 10px;
}

.padding-r-s {
  padding-right: 10px;
}

.padding-r-m {
  padding-right: 20px;
}

.padding-r-xl {
  padding-right: 60px;
}

.text-centered {
  text-align: center;
}

.text-bold {
  font-weight: bold;
}

.text-small {
  font-size: 14px;
}

.text-medium {
  font-size: 20px;
}

.text-large {
  font-size: 24px;
}

.text-xlarge {
  font-size: 28px;
}

.text-uppercase {
  text-transform: uppercase;
}

.is-loading,
.loading {
  color: #ececec;
  background-color: #ececec;
}
.is-loading::selection, .is-loading::-moz-selection,
.loading::selection,
.loading::-moz-selection {
  background: #ececec;
}

@media screen and (max-width: ) {
  body:before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 375px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 640px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 768px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1024px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1280px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1440px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1600px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
/*
	usage:

	.element {
		@include browserfix(ie) {
			&:after {
				content: "This is IE only"
			}
		}
		@include browserfix(firefox) {
			&:after {
				content: "Only Firefox users will see this";
			}
		}
	}
*/
@keyframes buttonDisabled {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
.srprs-list ~ .srprs-listheader {
  margin-top: 15px;
}

.srprs-listheader {
  position: relative;
  width: 100%;
  line-height: 0;
  margin-bottom: 5px;
}
.srprs-listheader::after {
  clear: both;
  content: "";
  display: table;
}
.srprs-listheader:before {
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 0;
  width: 100%;
  height: 1px;
  content: "";
  background-color: #e7e7e7;
}
.srprs-listheader > span {
  position: relative;
  float: left;
  z-index: 2;
  margin-left: 10px;
  padding-right: 10px;
  padding-left: 10px;
  font-weight: bold;
  font-size: 16px;
  font-family: font-body, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  line-height: 30px;
  background: #fff;
}
.srprs-listheader > img {
  position: absolute;
  background-color: #fff;
  z-index: 10;
  display: none;
  float: right;
}
.srprs-listheader.no-margin-left > span {
  margin-left: 0;
  padding-left: 0;
  font-family: font-body, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
}
.srprs-listheader.no-margin-bottom {
  margin-bottom: 0;
}
.srprs-listheader.is-uppercase > span {
  text-transform: uppercase;
}
.srprs-listheader > a,
.srprs-listheader > .srprs-button {
  position: relative;
  float: right;
  z-index: 2;
  padding-top: 4px;
  padding-right: 18px;
  padding-bottom: 4px;
  padding-left: 18px;
  margin-right: 10px;
  font-family: font-body, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-transform: none;
  border-width: 1px;
  border-style: solid;
  border-color: #e7e7e7;
}
.srprs-listheader > a {
  border: none;
}

@media screen and (min-width: 375px) {
  .srprs-listheader > span {
    margin-left: 14px;
    padding-right: 13px;
    padding-left: 13px;
  }
  .srprs-listheader.no-margin-left > span {
    margin-left: 0;
    padding-left: 0;
  }
  .srprs-listheader > .srprs-button {
    margin-right: 26px;
    font-size: 16px;
  }
}
@media screen and (min-width: 1024px) {
  .srprs-listheader {
    margin-bottom: 10px;
  }
  .srprs-listheader > span {
    font-size: 18px;
  }
  .srprs-listheader > img {
    display: block;
    height: 160px;
    top: -82px;
    right: -50px;
  }
  .srprs-listheader.is-uppercase > span {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./../srprsme-react-components/src/components/_Assets/scss/_core.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/_helpers.scss","webpack://./../srprsme-react-components/src/components/ListHeader/ListHeader.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_breakpoint.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_browser-fixes.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/animations/_Button.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_clearfix.scss"],"names":[],"mappings":"AAEA;;;;;;;;;;;CAAA;ACAA;EACE,cAAA;ACWF;;ADRA;EACE,eAAA;ACWF;ADVE;EAFF;IAGI,aAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADTE;EADF;IAEI,WAAA;ECaF;AACF;;ADTE;EADF;IAEI,UAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADVA;EACE,YAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADVA;EACE,gBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADXA;EACE,eAAA;ACcF;;ADZA;EACE,eAAA;ACeF;;ADbA;EACE,eAAA;ACgBF;;ADdA;EACE,eAAA;ACiBF;;ADfA;EACE,yBAAA;ACkBF;;ADfA;;EAEE,cAAA;EACA,yBAAA;ACkBF;ADjBE;;;EAEE,mBAAA;ACoBJ;;ACpFA;EAEI;IACE,iBAAA;IACA,aAAA;EDsFJ;AACF;ACvHI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDoEN;AACF;AC7HI;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED0EN;AACF;ACnII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDgFN;AACF;ACzII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDsFN;AACF;AC/II;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED4FN;AACF;ACrJI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDkGN;AACF;AC3JI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDwGN;AACF;AEzIA;;;;;;;;;;;;;;;CAAA;AChCA;EACE;IAEE,kCAAA;EH0LF;EGxLA;IAEE,iCAAA;EHyLF;EGvLA;IAGE,kCAAA;EHuLF;EGrLA;IAEE,iCAAA;EHsLF;AACF;AArMA;EAEI,gBAAA;AAsMJ;;AAlMA;EAEE,kBAAA;EACA,WAAA;EACA,cAAA;EAEE,kBAAA;AAmMJ;AIhNE;EACE,WAAA;EACA,WAAA;EACA,cAAA;AJkNJ;AArME;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EAEE,yBAAA;AAsMN;AAlME;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EAEE,iBAAA;EAGA,mBAAA;EACA,kBAAA;EAGA,iBAAA;EACA,eAAA;EACA,2IAAA;EAEF,iBAAA;EACA,gBAAA;AA8LJ;AA3LE;EACE,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;AA6LJ;AAzLI;EAEI,cAAA;EAGA,eAAA;EAGA,2IAAA;AAsLR;AAjLE;EACE,gBAAA;AAmLJ;AA/KI;EACE,yBAAA;AAiLN;AA7KE;;EAEE,kBAAA;EACA,YAAA;EACA,UAAA;EAEE,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EAGA,kBAAA;EAGA,2IAAA;EACA,gBAAA;EACA,eAAA;EAGA,iBAAA;EAGA,oBAAA;EAGA,iBAAA;EACA,mBAAA;EACA,qBAAA;AAoKN;AAhKE;EACE,YAAA;AAkKJ;;ACjRI;EDqHA;IAEI,iBAAA;IAGA,mBAAA;IACA,kBAAA;EA6JN;EAxJI;IAEI,cAAA;IAGA,eAAA;EAuJR;EAlJE;IAEI,kBAAA;IAGA,eAAA;EAiJN;AACF;ACjSI;EDsJF;IAEI,mBAAA;EA6IJ;EA3IE;IAEI,eAAA;EA4IN;EAzIE;IACE,cAAA;IACA,aAAA;IACA,UAAA;IACA,YAAA;EA2IJ;EAxII;IAEI,eAAA;EAyIR;AACF","sourcesContent":["@charset \"UTF-8\";\n\n/*\n\tFILE: _core.scss\n\n\tUSED ON:\n\t\t- srprs.me/*\n\n\tUSAGE:\n\t\tMeant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1\n\n\tNOTES:\n\t\tNEVER use @import \"base/*\"; or such, read this => http://stackoverflow.com/a/4779432\n*/\n\n// vars & helpers\n@import 'helpers/variables';\n@import 'helpers/helpers';\n\n// functions\n@import 'helpers/functions/map-deep-get';\n@import 'helpers/functions/color';\n@import 'helpers/functions/font';\n//@import \"helpers/functions/padding\";\n@import 'helpers/functions/section';\n@import 'helpers/functions/str-replace';\n@import 'helpers/functions/z-index';\n\n// mixins\n@import 'helpers/mixins/arrow';\n@import 'helpers/mixins/aspect-ratio';\n@import 'helpers/mixins/breakpoint';\n@import 'helpers/mixins/browser-fixes';\n@import 'helpers/mixins/color-schemes';\n@import 'helpers/mixins/grid';\n@import 'helpers/mixins/no-bullets';\n@import 'helpers/mixins/clearfix';\n@import 'helpers/mixins/font-face';\n@import 'helpers/mixins/scrollbars';\n@import 'helpers/mixins/transform-center';\n@import 'helpers/mixins/transition';\n@import 'helpers/mixins/truncate';\n\n// repeatables (aka think DRY and store it in an @mixin)\n@import 'helpers/repeatables/box-shadow';\n@import 'helpers/repeatables/iphonex';\n@import 'helpers/repeatables/wrapper-inner';\n\n// animations\n@import 'animations/Button';\n","@charset \"UTF-8\";\n\n.clearfix {\n  overflow: auto;\n}\n\n.display-flex {\n  display: inline;\n  @media only screen and (min-width: 767px) {\n    display: flex;\n  }\n}\n\n.full-width {\n  width: 100%;\n}\n\n.mobile-full-width {\n  @media only screen and (max-width: 767px) {\n    width: 100%;\n  }\n}\n\n.width-49 {\n  @media only screen and (min-width: 767px) {\n    width: 49%;\n  }\n}\n\n.pull-left {\n  float: left;\n}\n\n.pull-right {\n  float: right;\n}\n\n.margin-b-s {\n  margin-bottom: 10px;\n}\n\n.margin-b-m {\n  margin-bottom: 20px;\n}\n\n.margin-b-l {\n  margin-bottom: 40px;\n}\n\n.padding-t-s {\n  padding-top: 10px;\n}\n\n.padding-t-s-7 {\n  padding-top: 7px;\n}\n\n.padding-l-s {\n  padding-left: 10px;\n}\n\n.padding-r-s {\n  padding-right: 10px;\n}\n\n.padding-r-m {\n  padding-right: 20px;\n}\n\n.padding-r-xl {\n  padding-right: 60px;\n}\n\n.text-centered {\n  text-align: center;\n}\n\n.text-bold {\n  font-weight: bold;\n}\n.text-small {\n  font-size: 14px;\n}\n.text-medium {\n  font-size: 20px;\n}\n.text-large {\n  font-size: 24px;\n}\n.text-xlarge {\n  font-size: 28px;\n}\n.text-uppercase {\n  text-transform: uppercase;\n}\n\n.is-loading,\n.loading {\n  color: #ececec;\n  background-color: #ececec;\n  &::selection,\n  &::-moz-selection {\n    background: #ececec;\n  }\n}\n","@charset \"UTF-8\";\n@import '../_Assets/scss/core';\n\n// Add margin top to srprs-listheader if it comes after a srprs-list\n.srprs-list ~ .srprs-listheader {\n  margin: {\n    top: 15px;\n  }\n}\n\n.srprs-listheader {\n  @include clearfix;\n  position: relative;\n  width: 100%;\n  line-height: 0;\n  margin: {\n    bottom: 5px;\n  }\n\n  &:before {\n    position: absolute;\n    z-index: 1;\n    top: 50%;\n    left: 0;\n    width: 100%;\n    height: 1px;\n    content: '';\n    background: {\n      color: color(grey-light);\n    }\n  }\n\n  > span {\n    position: relative;\n    float: left;\n    z-index: 2;\n    margin: {\n      left: 10px;\n    }\n    padding: {\n      right: 10px;\n      left: 10px;\n    }\n    font: {\n      weight: bold;\n      size: 16px;\n      family: font(body);\n    }\n    line-height: 30px;\n    background: color(white);\n  }\n\n  > img {\n    position: absolute;\n    background-color: color(white);\n    z-index: 10;\n    display: none;\n    float: right;\n  }\n\n  &.no-margin-left {\n    > span {\n      margin: {\n        left: 0;\n      }\n      padding: {\n        left: 0;\n      }\n      font: {\n        family: font(heading);\n      }\n    }\n  }\n\n  &.no-margin-bottom {\n    margin-bottom: 0;\n  }\n\n  &.is-uppercase {\n    > span {\n      text-transform: uppercase;\n    }\n  }\n\n  > a,\n  > .srprs-button {\n    position: relative;\n    float: right;\n    z-index: 2;\n    padding: {\n      top: 4px;\n      right: 18px;\n      bottom: 4px;\n      left: 18px;\n    }\n    margin: {\n      right: 10px;\n    }\n    font: {\n      family: font(body);\n      weight: 500;\n      size: 14px;\n    }\n    line: {\n      height: 20px;\n    }\n    text: {\n      transform: none;\n    }\n    border: {\n      width: 1px;\n      style: solid;\n      color: color(grey-light);\n    }\n  }\n\n  > a {\n    border: none;\n  }\n}\n\n@include breakpoint(mobile-large) {\n  .srprs-listheader {\n    > span {\n      margin: {\n        left: 14px;\n      }\n      padding: {\n        right: 13px;\n        left: 13px;\n      }\n    }\n\n    &.no-margin-left {\n      > span {\n        margin: {\n          left: 0;\n        }\n        padding: {\n          left: 0;\n        }\n      }\n    }\n\n    > .srprs-button {\n      margin: {\n        right: 26px;\n      }\n      font: {\n        size: 16px;\n      }\n    }\n  }\n}\n\n@include breakpoint(tablet-landscape) {\n  .srprs-listheader {\n    margin: {\n      bottom: 10px;\n    }\n    > span {\n      font: {\n        size: 18px;\n      }\n    }\n    > img {\n      display: block;\n      height: 160px;\n      top: -82px;\n      right: -50px;\n    }\n    &.is-uppercase {\n      > span {\n        font: {\n          size: 16px;\n        }\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n$breakpoints: map-deep-get($srprsreactwebsite-config, 'breakpoints');\n\n@mixin breakpoint($screensize) {\n  @if map-has-key($breakpoints, $screensize) {\n    @media screen and (min-width: map-get($breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (min-width: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$height-breakpoints: map-deep-get(\n  $srprsreactwebsite-config,\n  'height-breakpoints'\n);\n\n@mixin height-breakpoint($screensize) {\n  @if map-has-key($height-breakpoints, $screensize) {\n    @media screen and (max-height: map-get($height-breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (max-height: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$breakpoint-initial: map-deep-get(\n  $srprsreactwebsite-config,\n  'breakpoints',\n  's'\n);\n@media screen and (max-width: $breakpoint-initial) {\n  body {\n    &:before {\n      content: 'mobile';\n      display: none;\n    }\n  }\n}\n\n@each $breakpoint, $screensize in $breakpoints {\n  @include breakpoint(#{$screensize}) {\n    body {\n      &::before {\n        @if $breakpoint ==\n          l or\n          $breakpoint ==\n          xl or\n          $breakpoint ==\n          xxl or\n          $breakpoint ==\n          xxxl\n        {\n          content: 'desktop';\n        } @else if $breakpoint == m {\n          content: 'tablet';\n        } @else {\n          content: 'mobile';\n        }\n        display: none;\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n// we should thank http://browserhacks.com/ for this great roundup of dirt\n\n@mixin browserfix($browser) {\n  @if ($browser == 'ie') {\n    // the allmighty IE, 10 and up. 9 and lower requires usage of conditional comments, just stash your code in assets/styles/ie.scss\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      @content;\n    }\n  } @else if ($browser == 'firefox') {\n    // firefox 3 and up\n    @-moz-document url-prefix() {\n      @content;\n    }\n  } @else if ($browser == 'opera') {\n    // opera 9.5 and up\n    _:-o-prefocus,\n    body:last-child .selector {\n      @content;\n    }\n  } @else if ($browser == 'safari') {\n    // all safari\n    .selector:not(*:root) {\n      @content;\n    }\n  } @else if ($browser == 'chrome') {\n    // chrome 28 and up\n    @supports (-webkit-appearance: none) {\n      @content;\n    }\n  }\n}\n\n/*\n\tusage:\n\n\t.element {\n\t\t@include browserfix(ie) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"This is IE only\"\n\t\t\t}\n\t\t}\n\t\t@include browserfix(firefox) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"Only Firefox users will see this\";\n\t\t\t}\n\t\t}\n\t}\n*/\n","@charset \"UTF-8\";\n\n@keyframes buttonDisabled {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0);\n  }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0);\n  }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0);\n  }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0);\n  }\n}\n","@charset \"UTF-8\";\n\n@mixin clearfix {\n  &::after {\n    clear: both;\n    content: '';\n    display: table;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
